var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUseModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/32px/icoUseModel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockups-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2-Experiment---Other-models-modal---Short-Copy",
    transform: "translate(-972.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron",
    transform: "translate(972.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6A61",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) ",
    points: "8 10 12 14 16 10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUseModel);
export default __webpack_public_path__ + "static/media/icoUseModel.34a12d9d816bb173e2a31184791cb2c3.svg";
export { ForwardRef as ReactComponent };